import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfPersonasEmpleadosServicios } from '@/modules/Administracion/interfaces'
import type { IResponseApi, IResponseApiSearch } from '@/modules/Core/interfaces'
import type { AxiosResponse } from 'axios'
import type { IAssignServicesToEmployees } from '../interfaces/tablas/IConfPersonasEmpleadosServicios'
import type { IEmpleadoServicioExcel } from '../composables/useEmployeesServices'
export class ServicioEmpleadoService extends BaseService<IConfPersonasEmpleadosServicios> {
  constructor() {
    super({
      baseUrl: 'system/employee-services/'
    })
  }

  async asignarServiciosToEmpleados(
    employeeId: number,
    payload: IAssignServicesToEmployees
  ): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http
      .post<
        IResponseApi<string>
      >(`/assignServicesToEmployees/${employeeId}`, payload)
      .catch(this.errorHandle)
  }
  async searchServicio(
    id: number | string,
    params?: Record<string, unknown>
  ): Promise<
    AxiosResponse<IResponseApiSearch<IConfPersonasEmpleadosServicios[]>>
  > {
    return this.http
      .get<
        IResponseApiSearch<IConfPersonasEmpleadosServicios[]>
      >(`/search/${id}`, { params })
      .catch(this.errorHandle)
  }
  async postFileArray(
    url: string,
    data: FormData
  ): Promise<AxiosResponse<IResponseApi<IEmpleadoServicioExcel[]>>> {
    return this.http
      .post<IResponseApi<IEmpleadoServicioExcel[]>>(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .catch(this.errorHandle)
  }
}
